import React from 'react';
import { FaUsers, FaLaptop, FaVideo, FaBook } from 'react-icons/fa';

export default function WhyChooseUs() {
    return (
        <section className="py-24 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
            {/* Modern Geometric Background */}
            <div className="absolute inset-0">
                <div className="absolute top-20 left-20 w-32 h-32 bg-blue-100 transform rotate-45 opacity-30"></div>
                <div className="absolute top-40 right-32 w-24 h-24 bg-gray-200 rounded-full opacity-40"></div>
                <div className="absolute bottom-32 left-32 w-40 h-40 bg-blue-50 transform rotate-12 opacity-50"></div>
                <div className="absolute bottom-20 right-20 w-28 h-28 bg-gray-100 rounded-full opacity-30"></div>
            </div>

            <div className="max-w-6xl mx-auto px-6 relative">
                {/* Modern Header Design */}
                <div className="text-center mb-16">
                    <div className="inline-block mb-6">
                        <div className="flex items-center gap-2 bg-white border-2 border-blue-100 rounded-2xl px-6 py-3 shadow-sm">
                            <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                            <span className="text-blue-700 font-semibold text-sm lemon-milk">EXCELLENCE IN EDUCATION</span>
                            <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                        </div>
                    </div>

                    <h2 className="text-5xl font-black text-gray-900 mb-4 lemon-milk">
                        Why Choose <span className="text-blue-600 relative">
                            Sudesh Maths
                            <div className="absolute -bottom-2 left-0 right-0 h-1 bg-blue-200 rounded-full"></div>
                        </span>?
                    </h2>

                    <div className="max-w-2xl mx-auto">
                        <p className="text-xl text-gray-600 leading-relaxed poppins">
                            Discover what makes us the preferred choice for thousands of students seeking excellence in education.
                        </p>
                    </div>
                </div>

                {/* Modern Grid Layout */}
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {/* Physical Classes - Modern Card */}
                    <div className="group relative">
                        <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl transform rotate-1 group-hover:rotate-0 transition-transform duration-300 opacity-10"></div>
                        <div className="relative bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                            <div className="flex flex-col items-center text-center">
                                <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300">
                                    <FaUsers className="text-white text-xl" />
                                </div>
                                <h3 className="text-lg font-bold text-gray-900 mb-3 lemon-milk">Physical Classes</h3>
                                <p className="text-gray-600 text-sm leading-relaxed poppins">
                                    Direct instruction with hands-on learning and real-time interaction for maximum engagement.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Online Classes - Modern Card */}
                    <div className="group relative">
                        <div className="absolute inset-0 bg-gradient-to-r from-gray-500 to-gray-600 rounded-2xl transform -rotate-1 group-hover:rotate-0 transition-transform duration-300 opacity-10"></div>
                        <div className="relative bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                            <div className="flex flex-col items-center text-center">
                                <div className="w-16 h-16 bg-gray-600 rounded-2xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300">
                                    <FaLaptop className="text-white text-xl" />
                                </div>
                                <h3 className="text-lg font-bold text-gray-900 mb-3 lemon-milk">Online Classes</h3>
                                <p className="text-gray-600 text-sm leading-relaxed poppins">
                                    Interactive virtual learning with live discussions and instant feedback from anywhere.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Class Recording - Modern Card */}
                    <div className="group relative">
                        <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-500 rounded-2xl transform rotate-1 group-hover:rotate-0 transition-transform duration-300 opacity-10"></div>
                        <div className="relative bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                            <div className="flex flex-col items-center text-center">
                                <div className="w-16 h-16 bg-blue-500 rounded-2xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300">
                                    <FaVideo className="text-white text-xl" />
                                </div>
                                <h3 className="text-lg font-bold text-gray-900 mb-3 lemon-milk">Class Recording</h3>
                                <p className="text-gray-600 text-sm leading-relaxed poppins">
                                    Flexible learning with recorded sessions you can pause, rewind, and replay anytime.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Study Packs - Modern Card */}
                    <div className="group relative">
                        <div className="absolute inset-0 bg-gradient-to-r from-gray-400 to-gray-500 rounded-2xl transform -rotate-1 group-hover:rotate-0 transition-transform duration-300 opacity-10"></div>
                        <div className="relative bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                            <div className="flex flex-col items-center text-center">
                                <div className="w-16 h-16 bg-gray-500 rounded-2xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300">
                                    <FaBook className="text-white text-xl" />
                                </div>
                                <h3 className="text-lg font-bold text-gray-900 mb-3 lemon-milk">Study Packs</h3>
                                <p className="text-gray-600 text-sm leading-relaxed poppins">
                                    Comprehensive resources with pre-recorded lectures, tutorials, and study materials.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modern Stats Section */}
                <div className="mt-16 bg-white rounded-3xl p-8 shadow-lg border border-gray-100">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                        <div className="text-center">
                            <div className="text-3xl font-black text-blue-600 lemon-milk">10K+</div>
                            <div className="text-sm text-gray-600 poppins">Students</div>
                        </div>
                        <div className="text-center">
                            <div className="text-3xl font-black text-gray-700 lemon-milk">500+</div>
                            <div className="text-sm text-gray-600 poppins">Instructors</div>
                        </div>
                        <div className="text-center">
                            <div className="text-3xl font-black text-blue-600 lemon-milk">50+</div>
                            <div className="text-sm text-gray-600 poppins">Courses</div>
                        </div>
                        <div className="text-center">
                            <div className="text-3xl font-black text-gray-700 lemon-milk">98%</div>
                            <div className="text-sm text-gray-600 poppins">Success Rate</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
